import { makeStyles } from '@fluentui/react-components';

export const useKaiaContactFormDialogStyles = makeStyles({
    surface: {
        maxWidth: '90vw',
        height: '100%',
        maxHeight: '90vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    iframe: {
        transitionProperty: 'opacity',
        transitionDuration: '0.2s',
    },
    iframeLoading: {
        opacity: '0',
    },
    iframeLoaded: {
        opacity: '1',
    },
});
